export const projects = [
  {
    title: "this.Site",
    subtitle: "React",
    description:
      "This site was built using React and Tailwind CSS. It is hosted on Netlify.",
    image: "this-site.svg",
    link: "https://github.com/cconway1-stevens/my-portfolio",
  },
  {
    title: "ChoreNScore",
    subtitle: "React",
    description: "This site was built using React and Firebase as a backend.",
    image: "ChoreNScore.svg",
    link: "https://www.canva.com/design/DAFTc0p9H2E/xIRLxMxXTKcup87oQFA5gA/watch?utm_content=DAFTc0p9H2E&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink",
  },
  {
    title: "DocuTransform",
    subtitle: "Streamlit",
    description: 
      "A versatile file conversion tool utilizing Streamlit for seamless transformation of text files into Markdown, Word, PDF, and RTF formats. Featuring LaTeX-like equation formatting and dynamic image placeholder replacement.",
    image: "DocuTransform (2).png",
    link: "https://github.com/cconway1-stevens/chat-helper"
    
  },
  {
    title: "PenguinAI",
    subtitle: "TensorFlow & AI/ML",
    description: 
      "A cutting-edge AI/ML project that leverages TensorFlow to classify penguin species with high accuracy. This project involves custom training loops, neural network optimization, and advanced data preprocessing techniques. Skills acquired include deep learning, model evaluation, and predictive analytics, showcasing proficiency in building and deploying sophisticated machine learning models.",
    image: "p.png",
    link: "https://github.com/cconway1-stevens/AI",
  }
];

export const tags = [
  "HTML",
  "CSS",
  "JavaScript",
  "Typescript",
  "Tailwind",
  "React",
  "Next.js",
  "Gatsby",
  "UI/UX",
  "SVG",
  "animation",
  "webdev",
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  {
    name: "Front-end Development",
    tags: ["HTML", "CSS", "JavaScript", "React", "Vue", "Angular", "Tailwind CSS"],
  },
  {
    name: "Back-end Development",
    tags: ["Node.js", "Python", "Ruby on Rails", "PHP", "Django", "Flask", "Firebase"],
  },
  {
    name: "Software Development",
    tags: [
      "SolidWorks",
      "Arduino",
      "AutoCAD",
      "Microsoft Office (Word, PowerPoint, Excel, Visio)",
      "LabVIEW",
      "C#",
      "C++",
      "Java",
      "MATLAB",
      "Python",
      "HTML",
      "React",
      "Swift",
      "Git (GitHub/GitLab/SVN)",
      "Docker",
      "Kubernetes",
      "Jenkins",
      "CI/CD",
    ],
  },
  {
    name: "Project Management",
    tags: [
      "Client Liaison",
      "Requirements Gathering",
      "Budgeting",
      "Incident Reporting",
      "Maintenance Requests",
      "Room Transfers",
      "Interview Facilitation",
      "Agile",
      "Scrum",
      "Kanban",
    ],
  },
  {
    name: "UI/UX Design",
    tags: ["Figma", "Consumer Interviews", "Design Presentations", "Sketch", "Adobe XD"],
  },
  {
    name: "Research",
    tags: [
      "Experimentation",
      "Data Recording & Processing",
      "Lab Instrument Calibration & Operation",
      "Statistical Analysis",
      "Survey Design",
    ],
  },
  {
    name: "Teaching and Mentoring",
    tags: [
      "Material Development",
      "Feedback Provision",
      "Guest Lecture Assistance",
      "Workshop Facilitation",
      "Peer Tutoring",
    ],
  },
  {
    name: "Interpersonal Skills",
    tags: [
      "Relationship Building",
      "Counseling",
      "Diversity & Inclusion Program Development",
      "Conflict Resolution",
    ],
  },
  {
    name: "Data Analysis and Machine Learning",
    tags: [
      "Pandas",
      "NumPy",
      "SciPy",
      "Matplotlib",
      "TensorFlow",
      "Keras",
      "PyTorch",
      "scikit-learn",
      "OpenCV",
      "NLTK",
      "Hugging Face",
      "Transformers",
      "Computer Vision",
      "Natural Language Processing",
      "Deep Learning",
      "Neural Networks",
    ],
  },
  {
    name: "Audio Editing",
    tags: ["Audacity", "Adobe Audition"],
  },
  {
    name: "Accounting Software",
    tags: ["QuickBooks Pro", "BookWorks", "Xero"],
  },
  {
    name: "Document Editing and Creation",
    tags: ["Adobe Acrobat Suite", "Microsoft Word", "Google Docs"],
  },
];


export const documents = [
  {
    title: "Resume",
    subtitle: "PDF",
    description:
      "Comprehensive resume highlighting extensive experience in software engineering and project management.",
    image: "./resume.jpg",
    link: "./resume.jpg",
  },
];

export const jobExperiences = [
  {
    title: "Junior Software Engineer",
    company: "F&S Digital",
    location: "New Jersey, United States",
    startDate: "2022-05-01",
    endDate: null, // Ongoing job
    responsibilities: [
      "Conducted over 50 in-depth customer interviews with clients from industry leaders like Netflix, Amazon, and Dell, resulting in a 30% increase in the accuracy of software requirements documentation.",
      "Strategically planned and executed 10+ software development projects for prominent companies such as State Farm, Electronic Arts, and StubHub, delivering solutions that improved user satisfaction scores by 25%.",
      "Identified and implemented cutting-edge software solutions that reduced technological challenges by 40%, enhancing overall system performance for clients like Hard Rock, Outback Steakhouse, and VSCO.",
      "Led a cross-functional team of 5 developers, ensuring project requirements were met ahead of deadlines and under budget, which resulted in a 20% increase in team productivity and successful collaborations with companies like Dell and State Farm.",
      "Acted as the primary communication liaison between clients and the development team, ensuring clear and consistent updates. This improved client satisfaction ratings by 35% and strengthened relationships with vendors such as the Greater Atlantic City Chamber and the Garden State Film Festival.",
    ],
  },
  {
    title: "Technical Support and Media Relation Specialist",
    company: "Ocean Heights Auto and Tire",
    location: "Egg Harbor, New Jersey, United States",
    startDate: "2021-09-01",
    endDate: null, // Ongoing job
    responsibilities: [
      "Provide excellent customer support: Ensuring that customers receive timely and effective technical assistance and support, addressing their queries and concerns related to automotive products and services.",
      "Enhance customer satisfaction: Striving to exceed customer expectations by delivering high-quality technical support and media communications, resulting in increased customer satisfaction and loyalty.",
      "Increase brand visibility: Utilizing various media platforms and strategies to enhance the company's presence and reach, attracting new clients and strengthening the brand's reputation in the automotive industry.",
      "Manage media channels effectively: Maintaining and managing media platforms, including social media, websites, and blogs, to consistently engage with the audience, share relevant content, and foster positive relationships with customers and stakeholders.",
      "Foster positive media relations: Building strong relationships with media outlets, influencers, and journalists, ensuring positive media coverage and managing media inquiries efficiently to uphold a favorable brand image and reputation.",
    ],
  },
  {
    title: "Electrical Engineering Lab Instructor",
    company: "Stevens Institute of Technology",
    location: "Hoboken, New Jersey, United States",
    startDate: "2023-09-01",
    endDate: "2024-05-01",
    responsibilities: [
      "Manage and supervise undergraduate laboratory course, ensuring alignment with course objectives.",
      "Plan, execute, and monitor lab projects, providing hands-on support and ensuring project milestones are met.",
      "Utilize advanced lab equipment, including oscilloscopes, signal generators, and multimeters, to conduct and oversee experiments.",
      "Develop and refine lab curricula in collaboration with faculty, integrating new methods and technologies.",
      "Provide one-on-one and group assistance to students, offering feedback on lab work and reports.",
      "Ensure compliance with safety regulations and maintain a safe laboratory environment.",
      "Oversee the maintenance and calibration of lab equipment to ensure all tools and instruments are in proper working order.",
    ],
  },
  {
    title: "Resident Assistant",
    company: "Stevens Institute of Technology",
    location: "Hoboken, New Jersey, United States",
    startDate: "2020-08-01",
    endDate: "2024-05-01",
    responsibilities: [
      "Spearheaded administrative initiatives, including advanced scheduling systems and resource management software, resulting in a 50% student enrollment increase with existing resources.",
      "Facilitated liaison efforts between the academy and external partners, utilizing CRM software to cultivate relationships that enhanced program visibility and support.",
      "Orchestrated data entry and reporting tasks using database management tools, ensuring accuracy and timely submission of detailed reports.",
      "Coordinated the organization and execution of academy events, employing event management software to streamline processes and increase student participation by 24%.",
      "Shepherded the maintenance of the STEM PUSH program, an NSF grant initiative aimed at improving STEM education and engagement among underrepresented groups.",
      "Engaged in annual flights to Pittsburgh for conferences focused on Diversity, Equity, and Inclusion (DEI) in STEM, presenting research findings and collaborating with industry leaders.",
    ],
  },
  {
    title: "Graduate Research Assistant for DoD",
    company: "Stevens Institute of Technology",
    location: "Hoboken, New Jersey, United States",
    startDate: "2022-12-01",
    endDate: "2023-08-01",
    responsibilities: [
      "Led experiments on sustainable wastewater treatment technologies, improving nutrient removal efficiency by 15% and contributing to a Department of Defense-funded project.",
      "Operated and calibrated advanced lab instruments, including IC and HPLC, ensuring accurate data collection and analysis.",
      "Published findings in a peer-reviewed journal, showcasing the impact of the research on sustainable engineering practices.",
      "Collaborated with a team of 5 researchers, enhancing project outcomes through effective teamwork.",
      "Presented research at national conferences, increasing the visibility of the project.",
    ],
  },
  {
    title: "Systems Researcher for NASA",
    company: "NASA",
    location: "Hoboken, New Jersey, United States",
    startDate: "2023-05-01",
    endDate: "2023-09-01",
    responsibilities: [
      "Developed a user-friendly graphical interface for NASA’s Earth Science Technology Office's NOS Testbed, completed in a record one-month timeframe.",
      "Conducted comprehensive user testing, incorporating feedback to enhance usability, resulting in a 40% increase in user satisfaction.",
      "Presented project outcomes to key stakeholders at NASA Headquarters, highlighting the interface's role in advancing Earth science missions.",
      "Coordinated with a multidisciplinary team, ensuring seamless integration of various project components.",
      "Authored technical documentation and user manuals, facilitating the effective use of the NOS Testbed interface.",
    ],
  },
  {
    title: "Biomedical & Technical Engineering Intern",
    company: "US Instruments INC",
    location: "New Jersey, United States",
    startDate: "2021-05-01",
    endDate: "2021-09-01",
    responsibilities: [
      "Increased user efficiency by 16% through the integration of new UI/UX protocols based on customer feedback.",
      "Diagnosed and repaired sensitive microchips for Parks Flow Lab, enhancing device performance and reliability.",
      "Conducted annual maintenance checks on terminals, ensuring optimal operation and compliance with industry standards.",
      "Assisted in the development of new diagnostic tools, reducing the average time required for accurate diagnosis by approximately 2-3 weeks.",
      "Provided technical support to clients, resolving issues and improving customer satisfaction by 20%.",
    ],
  },
  {
    title: "Administrative Graduate Assistant",
    company: "Art Harper Saturday Academy",
    location: "Hoboken, New Jersey, United States",
    startDate: "2023-08-01",
    endDate: "2024-05-01",
    responsibilities: [
      "Coordinate and manage program activities, including scheduling, resource management, and event planning, working with a staff of around 18 members.",
      "Assist in developing and distributing educational materials and program curricula, contributing to a 50% increase in student engagement and retention.",
      "Serve as a primary point of contact for over 100 students and parents, addressing inquiries and providing comprehensive information about the program.",
      "Support the recruitment, onboarding, and selection process of new participants, reviewing over 200 applications annually and coordinating interviews.",
      "Facilitate and promote the NSF-funded STEM PUSH initiative, ensuring program alignment with its goals and objectives, and contributing to a 15% increase in program funding.",
      "Manage and allocate an $8,000 discretionary budget, optimizing resource use and enhancing program effectiveness.",
      "Travel to and represent the program at annual conferences, showcasing the impact and success of the Art Harper Saturday Academy to national and international audiences.",
      "Monitor and evaluate program effectiveness through data analysis and feedback, compiling reports that demonstrate a 60% improvement in student performance and outcomes.",
      "Facilitate communication between program participants, staff, and external partners, ensuring timely and accurate information exchange.",
      "Organize and participate in over 20 events and activities annually that promote the academy and its mission, leading to a 40% increase in community involvement and support.",
    ],
  },
  {
    title: "Head Teaching Assistant",
    company: "Art Harper Saturday Academy",
    location: "Hoboken, New Jersey, United States",
    startDate: "2022-09-01",
    endDate: "2023-08-01",
    responsibilities: [
      "Provided guidance and support to teaching assistants and tutors in working with disadvantaged communities.",
      "Collaborated with academy staff to develop effective teaching strategies and curricula tailored to student needs.",
      "Delivered ongoing training and development for teaching assistants and tutors, enhancing their skills and knowledge.",
      "Assisted in the recruitment and selection of new teaching assistants and tutors.",
      "Monitored and evaluated the performance of teaching assistants and tutors to ensure alignment with academic standards and goals.",
      "Developed and implemented administrative initiatives, including scheduling, resource management, and stakeholder communication, in collaboration with academy staff.",
      "Served as a liaison between the academy and external partners such as schools, community organizations, and volunteers.",
      "Organized and participated in events and activities that promote the academy's mission.",
    ],
  },
  {
    title: "Lab Assistant",
    company: "Art Harper Saturday Academy",
    location: "Hoboken, New Jersey, United States",
    startDate: "2020-09-01",
    endDate: "2022-05-01",
    responsibilities: [
      "Assisted in conducting hands-on STEM experiments for high school students, improving their practical understanding of scientific concepts by 87%.",
      "Prepared and maintained laboratory equipment, ensuring a safe and efficient learning environment.",
      "Developed and implemented lab activities and projects, increasing student engagement and participation in STEM subjects.",
      "Provided one-on-one support to students during lab sessions, helping them to troubleshoot and solve complex problems.",
      "Coordinated with teaching staff to integrate lab activities with the overall curriculum, enhancing the coherence and effectiveness of the educational program.",
      "Managed inventory and ordered lab supplies, maintaining an optimal stock level and ensuring the availability of necessary materials.",
      "Compiled and analyzed lab data, providing insights that contributed to the refinement of teaching methods and lab procedures.",
    ],
  },
  {
    title: "STEM Mathematics Tutor",
    company: "Art Harper Saturday Academy",
    location: "Hoboken, New Jersey, United States",
    startDate: "2019-03-01",
    endDate: "2020-05-01",
    responsibilities: [
      "Provided comprehensive peer support to over 100 students, addressing a range of psychological and emotional issues and improving their overall mental well-being.",
      "Conducted 15 educational workshops on stress management, mental health awareness, and coping strategies, increasing student participation in counseling services by 20%.",
      "Collaborated with professional counselors to develop and implement peer support programs, enhancing the effectiveness of student mental health initiatives.",
      "Created and distributed educational materials on mental health topics, reaching over 500 students.",
      "Assisted in organizing mental health awareness events, attracting attendance from more than 300 students.",
    ],
  },
];

export const aboutContent = {
  introduction: {
    waveText: "👋",
    greeting: "Hi, I'm Cameron",
    tagline: "Welcome to my portfolio!",
    description1: "I'm a software engineer with a passion for solving tough problems and sparking innovation. I thrive on teamwork, collaborating with clients and dev squads to deliver top-notch results. My experience spans academia and professional projects, giving me a versatile skill set and fresh perspective.",
    description2: "Thanks for stopping by my little corner of the internet. Dive in, explore my work, and let’s make something awesome together. Ready to connect? How about we start with a cup of coffee (or two)? Hit that button and let’s brew up some great ideas!"
  },
  buttons: [
    {
      href: "#contact",
      text: "Let's Connect ☕️",
      classes: "button bg-green-500 hover:bg-green-600 rounded-lg py-2 px-6 text-lg transition-transform transform hover:scale-105",
    },
    {
      href: "https://www.linkedin.com/in/cameron-conway-07270819b/",
      text: "LinkedIn",
      classes: "button bg-gray-800 hover:bg-gray-700 rounded-lg py-2 px-6 text-lg transition-transform transform hover:scale-105",
      iconClass: "fab fa-linkedin"
    },
    {
      link: "https://www.canva.com/design/DAGDPQkDeAU/xDSaDYvQz6Lb61GN1ALc1Q/view?embed",
      text: "Resume",
    },
  ],
};

export const extraButtons = [
  {
    link: "https://www.canva.com/design/DAGDPQkDeAU/zSt_96-u3-e4tyAgoJJWAA/view?utm_content=DAGDPQkDeAU&utm_campaign=designshare&utm_medium=link&utm_source=editor",
    text: "Canva Link",
  },
];


// export const projects = [
//   // {
//   //   title: "This Site",
//   //   subtitle: "React",
//   //   description:
//   //     "This site was built using React and Tailwind CSS. It is hosted on Netlify.",
//   //   image: "project-1.gif",
//   //   link: "https://github.com/cconway1-stevens/my-portfolio"
//   // },
//   {
//     title: "this.Site",
//     subtitle: "React",
//     description:
//       "This site was built using React and Tailwind CSS. It is hosted on Netlify.",
//     image: "this-site.svg",
//     link: "https://github.com/cconway1-stevens/my-portfolio",
//   },
//   {
//     title: "ChoreNScore",
//     subtitle: "React",
//     description: "This site was built using React and firebase as a backend.",
//     //"ChoreNScore is a web application that allows users to create and manage chores for their household. Users can create chores, assign them to other users, and track the completion of chores. Users can also view their own chore history and the chore history of other users. This application was created using React, Node.js, Express, and MongoDB.",
//     image: "ChoreNScore.svg",
//     link: "https://www.canva.com/design/DAFTc0p9H2E/xIRLxMxXTKcup87oQFA5gA/watch?utm_content=DAFTc0p9H2E&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink",
//   },
// ];
// export const tags = [
//   "HTML",
//   "CSS",
//   "JavaScript",
//   "Typescript",
//   "Tailwind",
//   "React",
//   "Next.js",
//   "Gatsby",
//   "UI/UX",
//   "SVG",
//   "animation",
//   "webdev",
// ];

// export const testimonials = [
//   {
//     quote:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
//     image: "https://randomuser.me/api/portraits/men/1.jpg",
//     name: "Jesse Hicks",
//     company: "Zoozle",
//   },
//   {
//     quote:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
//     image: "https://randomuser.me/api/portraits/men/94.jpg",
//     name: "Ruben Alvarez",
//     company: "Dooble.io",
//   },
// ];

// // export const skills = [
// //   "JavaScript",
// //   "React",
// //   "Next.js",
// //   "Node",
// //   "GraphQL",
// //   "Material UI",
// // ];

// // export const skills = [
// //   "Software development: SolidWorks, Arduino, AutoCAD, Microsoft Office: Word, PowerPoint, Excel, Visio, LabVIEW, C#, C++, Java, MATLAB, Python, HTML, React",
// //   "Project Management: Liaising with clients, requirements gathering, budgeting, incident reporting, maintenance requests, room transfers, facilitating interviews",
// //   "UI/UX Design: Creating Figma models, conducting consumer interviews, presenting designs to clients",
// //   "Research: Conducting experiments, recording and processing experimental data, calibrating and operating lab instrumentation",
// //   "Teaching and Mentoring: Developing materials, providing feedback, assisting professors during guest lectures",
// //   "Interpersonal Skills: Building and fostering relationships, counseling, diversity and inclusion program development"
// // ];u

// export const skills = [
//   {
//     name: "Front-end Development",
//     tags: ["HTML", "CSS", "JavaScript", "React", "Vue", "Angular"],
//   },
//   {
//     name: "Back-end Development",
//     tags: ["Node.js", "Python", "Ruby on Rails", "PHP", "Django"],
//   },
//   {
//     name: "Software Development",
//     tags: [
//       "SolidWorks",
//       "Arduino",
//       "AutoCAD",
//       "Microsoft Office (Word, PowerPoint, Excel, Visio)",
//       "LabVIEW",
//       "C#",
//       "C++",
//       "Java",
//       "MATLAB",
//       "Python",
//       "HTML",
//       "React",
//       "Swift",
//       "Git (GitHub/GitLab/SVN)",
//       "Docker",
//       "Kubernetes",
//     ],
//   },
//   {
//     name: "Project Management",
//     tags: [
//       "Client Liaison",
//       "Requirements Gathering",
//       "Budgeting",
//       "Incident Reporting",
//       "Maintenance Requests",
//       "Room Transfers",
//       "Interview Facilitation",
//     ],
//   },
//   {
//     name: "UI/UX Design",
//     tags: [
//       "Figma",
//       "Consumer Interviews",
//       "Design Presentations",
//     ],
//   },
//   {
//     name: "Research",
//     tags: [
//       "Experimentation",
//       "Data Recording & Processing",
//       "Lab Instrument Calibration & Operation",
//     ],
//   },
//   {
//     name: "Teaching and Mentoring",
//     tags: [
//       "Material Development",
//       "Feedback Provision",
//       "Guest Lecture Assistance",
//     ],
//   },
//   {
//     name: "Interpersonal Skills",
//     tags: [
//       "Relationship Building",
//       "Counseling",
//       "Diversity & Inclusion Program Development",
//     ],
//   },
//   {
//     name: "Data Analysis and Machine Learning",
//     tags: [
//       "Pandas",
//       "NumPy",
//       "SciPy",
//       "Matplotlib",
//       "TensorFlow",
//       "Keras",
//       "PyTorch",
//     ],
//   },
//   {
//     name: "Audio Editing",
//     tags: ["Audacity"],
//   },
//   {
//     name: "Accounting Software",
//     tags: ["QuickBooks Pro", "BookWorks"],
//   },
//   {
//     name: "Document Editing and Creation",
//     tags: ["Adobe Acrobat Suite"],
//   },
// ];

// export const documents = [
//   {
//     title: "Resume",
//     subtitle: "PDF",
//     description:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
//     image: "./resume.jpg",
//     link: "./resume.jpg",
//   },
// ];

// export const jobExperiences = [
//   {
//     title: "SYSTEMS RESEARCHER",
//     company: "New Observing Strategies Testbed (NOS-T) Project for Collective Design Lab at Stevens via NASA/D.O.D",
//     location: "Hoboken, NJ",
//     duration: "May 2023 - September 2023",
//     responsibilities: [
//       "Crafted detailed consumer interviews with 20 users using structured questionnaires to extract critical user needs, pain points, and usage patterns, directly influencing product direction and design improvements.",
//       "Authored and optimized requirement documents that translated complex user research findings into clear, actionable instructions for engineers, contributing to a 29% increase in project efficiency.",
//       "Facilitated communication between end-users and engineering teams, enhancing project collaboration and reducing miscommunications by streamlining workflow processes.",
//       "Designed and refined high-fidelity Figma models based on iterative user feedback, which increased client satisfaction by 20% and accelerated project approval from initial concept stages.",
//     ],
//   },
//   {
//     title: "JUNIOR SOFTWARE ENGINEER",
//     company: "F&S Digital Agency",
//     location: "Ventnor, NJ",
//     duration: "May 2022 - January 2024",
//     responsibilities: [
//       "Conducted over 30 consumer interviews to identify user needs, leading to the development of detailed requirement documentation that guided engineering design and implementation.",
//       "Served as the key liaison for 5 major projects, facilitating effective communication between clients and a development team of 10 members, ensuring requirements alignment and project success.",
//       "Developed over 20 detailed Figma models for UI/UX projects, enhancing client understanding and approval rates by 30% through interactive presentations and requirement validations.",
//       "Engineered and prototyped an innovative software solution, leading to a successful sale under NDA; project resulted in a 20% performance improvement for the client’s operations.",
//     ],
//   },
//   {
//     title: "SOFTWARE AND TECHNICAL ENGINEERING INTERN",
//     company: "US Instruments INC",
//     location: "Lanoka Harbor, NJ",
//     duration: "April 2021 - September 2021",
//     responsibilities: [
//       "Enhanced the UI/UX efficiency of Parks Flow Lab® by 11.5%, following extensive user and stakeholder feedback.",
//       "Integrated new protocols into the sales system, reducing data entry errors by 8%.",
//       "Improved hardware-software integration by troubleshooting and repairing critical system components, enhancing system reliability.",
//     ],
//   },
//   {
//     title: "RESEARCH ASSISTANT",
//     company: "Stevens Department of Civil, Ocean, and Environmental Engineering",
//     location: "Hoboken, NJ",
//     duration: "November 2020 – May 2021",
//     responsibilities: [
//       "Spearheaded a Department of Defense-funded initiative to innovate sustainable and resilient wastewater treatment technologies, achieving significant advancements in environmental engineering.",
//       "Designed and conducted controlled experiments on nutrient-laden synthetic wastewater, employing meticulous attention to procedural detail which resulted in improved process efficiency and accuracy.",
//       "Mastered technical proficiency in calibrating and operating sophisticated laboratory instruments, including anion and cation ion chromatography (IC) and high-performance liquid chromatography (HPLC), to support high-stakes research projects.",
//       "Analyzed experimental data to track water treatment parameters such as pH, nitrate levels, and temperature, identifying key transformations that facilitate algal growth and energy production.",
//       "Operated a variety of specialized lab equipment, such as cation and anion analyzers, to execute critical research tasks and contribute to the development of groundbreaking wastewater treatment solutions.",
//     ],
//   },
// ];



// WEBPACK FOOTER //
// ./src/data.js